import { useInfiniteQuery } from 'react-query'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { type MeetingExpertHistoryDomain } from '../../../../types/domain/meeting-expert-history-domain'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { getValidFilters } from '../../../../utils/filters'
import { getQueryStrinfied } from '../../../../utils/query'
import { api } from '../../../api'

export const fetchMeetingsExpertHistoryById = async (id: number, filters: FiltersDomain) => {
  const queryParams = getQueryStrinfied(getValidFilters(filters))

  const response = await api.get<PaginationDomain<MeetingExpertHistoryDomain>>(
    `/meetings/expert-history/${id}?${queryParams}`
  )
  return response.data
}

export const useMeetingsExpertHistoryQuery = (id: number, filters: FiltersDomain) => {
  return useInfiniteQuery(
    ['meetings-history', id],
    ({ pageParam = 1 }) => fetchMeetingsExpertHistoryById(
      id, { ...filters, page: pageParam }
    ),
    {
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}
